import type {PrimerComponentSubnav} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentSubnav'
import {AnchorNav} from '@primer/react-brand/esm'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import Styles from './Nav.module.css'

type Props = {
  content: PrimerComponentSubnav
  themeMap?: Record<string, string>
}

const DEFAULT_THEME_MAP: Record<string, string> = {}

export function Nav(props: Props) {
  const {content, themeMap = DEFAULT_THEME_MAP} = props

  const {links} = content.fields

  return (
    <section className={Styles.Nav}>
      <AnchorNav>
        {links.map(link => {
          if ('href' in link.fields) {
            const href = link.fields.href
            // Extract the ID from the href (e.g., '#section-id' -> 'section-id')
            const sectionId = href.startsWith('#') ? href.slice(1) : null
            const theme = sectionId && themeMap[sectionId] ? themeMap[sectionId] : undefined

            return (
              <AnchorNav.Link
                key={link.sys.id}
                href={href}
                {...(theme ? {'data-theme': theme} : {})}
                {...getAnalyticsEvent({
                  action: link.fields.text,
                  tag: 'a',
                  context: 'anchor_nav_link',
                  location: 'anchor_nav',
                })}
              >
                {link.fields.text}
              </AnchorNav.Link>
            )
          }

          return null // Don't render LinkGroups
        })}
      </AnchorNav>
    </section>
  )
}
